import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IAddProductGoodsReceipt } from "mobx-stores/_models/product-inventory/product-goods-receipt/product-goods-receipt";
import { date, number, string } from "yup";

export const getAddProductGoodsReceiptSchema =
  (): ObjectSchemaType<IAddProductGoodsReceipt> => ({
    importDate: {
      type: InputType.datePicker,
      gridSize: 12,
      label: "Ngày nhập",
      validattionYupSchema: date().required(),
    },
    items: {
      arraySchema: {
        productId: {
          type: InputType.autoComplete,
          gridSize: 12,
          label: "Sản phẩm",
          validattionYupSchema: string().required(),
          metaData: createDomainPagedAutoCompleteMetaData("product"),
          defaultValue: "",
        },
        quantity: {
          type: InputType.number,
          gridSize: 6,
          label: "Số lượng",
          validattionYupSchema: number().required(),
          defaultValue: 0,
        },
        location: {
          type: InputType.text,
          gridSize: 6,
          label: "Vị trí",
          validattionYupSchema: string().required().max(255),
          defaultValue: "",
        },
        note: {
          type: InputType.textArea,
          gridSize: 12,
          label: "Ghi chú",
          validattionYupSchema: string().max(1024),
          defaultValue: "",
        },
      },
    },
  });
